import React, { useState } from 'react';
import Styles from './styles.module.css';

type DefaultInputProps = {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
};

export const schoolOptions = [
    "旭川理容美容専門学校",
    "北見美容専門学校",
    "釧路理容美容専門学校",
    "札幌ビューティーアート専門学校",
    "札幌ビューティックアカデミー",
    "札幌ベルエポック美容専門学校",
    "函館理容美容専門学校",
    "北海道芸術高等学校 札幌キャンパス",
    "北海道美容専門学校",
    "北海道理容美容専門学校",
    "青森県ビューティー&メディカル専門学校",
    "青森県ヘアアーチスト専門学校",
    "八戸理容美容専門学校",
    "岩手理容美容専門学校",
    "北日本ヘア・スタイリストカレッジ",
    "盛岡ヘアメイク専門学校",
    "東北ヘア－モード学院",
    "仙台理容美容専門学校",
    "東北芸術高等専修学校",
    "仙台ヘアメイク専門学校",
    "SENDAI中央理容美容専門学校",
    "仙台ビューティーアート専門学校",
    "秋田県理容美容専門学校",
    "秋田ヘアビューティカレッジ",
    "山形美容専門学校",
    "山形理容学校",
    "会津美容高等専修学校AIZUビューティーカレッジ",
    "iwakiヘアメイクアカデミー",
    "郡山理容学校",
    "福島県高等理容美容学院",
    "郡山ヘアメイクカレッジ",
    "国際ビューティー＆フード大学校",
    "茨城理容美容専門学校",
    "EIKA美容専門学校",
    "水戸ビューティーカレッジ",
    "水戸美容専門学校",
    "足利デザイン・ビューティ専門学校",
    "栃木県美容専門学校",
    "国際テクニカル美容専門学校",
    "国際テクニカル理容美容専門学校",
    "伊勢崎美容専門学校",
    "群馬県美容専門学校",
    "高崎ビューティモード専門学校",
    "グルノーブル美容専門学校",
    "埼玉県理容美容専門学校",
    "専門学校 トータルビューティカレッジ川越",
    "大宮理容美容専門学校",
    "大宮ビューティー＆ブライダル専門学校",
    "埼玉東萌美容専門学校",
    "ミス・パリ・ビューティ専門学校 大宮校",
    "東京ベイカレッジ",
    "ユニバーサル美容専門学校",
    "東洋理容美容専門学校",
    "パリ総合美容専門学校 千葉校",
    "千葉ビューティー＆ブライダル専門学校",
    "ジェイ ヘアメイク美容専門学校",
    "パリ総合美容専門学校 柏校",
    "千葉美容専門学校",
    "大竹高等専修学校",
    "国際共立学園高等専修学校",
    "すず学園高等専修学校",
    "専門学校 エビスビューティカレッジ",
    "東京文化美容専門学校",
    "東京マックス美容専門学校",
    "東京理容専修学校",
    "早稲田美容専門学校",
    "山野美容芸術短期大学",
    "資生堂美容技術専門学校",
    "中央理美容専門学校",
    "日本美容専門学校",
    "アポロ美容理容専門学校",
    "窪田理容美容専門学校",
    "国際文化理容美容専門学校 国分寺校",
    "国際文化理容美容専門学校 渋谷校",
    "国際理容美容専門学校",
    "コーセー美容専門学校",
    "住田美容専門学校",
    "高山美容専門学校",
    "タカラ美容専門学校",
    "東京総合美容専門学校",
    "東京ビューティーアート専門学校",
    "東京ビューティー＆ブライダル専門学校",
    "東京美容専門学校",
    "東京ベルエポック美容専門学校",
    "東京モード学園",
    "ハリウッド美容専門学校",
    "バンタンデザイン研究所",
    // "町田美容専門学校",
    "真野美容専門学校",
    "マリー・ルイズ美容専門学校",
    "ミスパリ ビューティ専門学校",
    "山野美容専門学校",
    "ベルエポック美容専門学校 原宿校",
    "アイム湘南美容教育専門学校",
    "M.D.F BEAUTY COLLEGE",
    "鎌倉早見美容芸術専門学校",
    "国際総合ビューティーカレッジ",
    "湘南ビューティカレッジ",
    "横浜芸術高等専修学校",
    "横浜市立横浜商業高等学校別科",
    "アーティスティックＢ横浜美容専門学校",
    "横浜ビューティー＆ブライダル専門学校",
    "神奈川ビューティー＆ビジネス専門学校",
    "横浜 ｆ カレッジ",
    "横浜理容美容専門学校",
    "クレア ヘアモード専門学校",
    "国際ビューティモード専門学校",
    "長岡美容専門学校",
    "新潟理容美容専門学校",
    "臼井美容専門学校",
    "専門学校 富山ビューティーカレッジ",
    "富山県理容美容専門学校",
    "石川県理容美容専門学校",
    "専門学校 金沢美専",
    "大原スポーツ医療保育福祉専門学校（美容科）",
    "福井県理容美容専門学校",
    "山梨県美容専門学校",
    "長野理容美容専門学校",
    "松本理容美容専門学校",
    "岐阜美容専門学校",
    "ベルフォート美容専門学校",
    "池田美容学校",
    "静岡アルス美容専門学校",
    "静岡県西部理容美容専門学校",
    "静岡県東部総合美容専門学校",
    "静岡デザイン専門学校",
    "タカヤマ アドバンス ビューティー専門学校",
    "浜松クレアックス ビューティーカレッジ",
    "フリーエース美容学校",
    "ルネサンス デザイン・美容専門学校",
    "IG BEAUTY ACADEMY",
    "愛知芸術高等専修学校",
    "愛知県東三高等美容学校",
    "愛知県東三高等理容学校",
    "愛知美容専門学校",
    "アクア理美容学校",
    "アリアーレビューティ専門学校",
    "安城生活福祉高等専修学校",
    "セブンティーン美容専門学校",
    "セントラルビューティストカレッジ",
    "専門学校 中部ビューティ・デザイン・デンタルカレッジ",
    "中部美容専門学校 岡崎校",
    "中部美容専門学校 名古屋校",
    "名古屋美容専門学校",
    "MOOビューティーアソシエイション",
    "名古屋理容美容専門学校",
    "名古屋ビューティ専門学校",
    "名古屋ビューティーアート専門学校",
    "東海美容学校",
    "名古屋綜合美容専門学校",
    "名古屋モード学園",
    "美容専門学校 アーティス・ヘアー・カレッジ",
    "ビーキュービック美容学校",
    "旭美容専門学校",
    "伊勢理容美容専門学校",
    "ミエ・ヘア・アーチストアカデミー",
    "アミューズ美容専門学校",
    "京都医健専門学校",
    "京都美容専門学校",
    "京都理容美容専修学校",
    "YIC京都ビューティ専門学校",
    "アイム・近畿理容美容専門学校",
    "アーデントビューティーカレッジ",
    "ヴェールルージュ美容専門学校",
    "NRB日本理容美容専門学校",
    "小出美容専門学校大阪校",
    "堺女子短期大学（美容文化コース）",
    "スタリアビューティーカレッジ",
    "理容美容専門学校 西日本ヘアメイクカレッジ",
    "ル・トーア東亜美容専門学校",
    "ロゼ＆ビューティ美容専門学院",
    "大阪樟蔭女子大学（学芸学部化粧ファッション学科）",
    "大阪ビューティーアート専門学校",
    "大阪ベルェベル美容専門学校",
    "桂make-upデザイン専門学校",
    "ECCアーティスト美容専門学校",
    "大阪モード学園",
    "関西美容専門学校",
    "高津理容美容専門学校",
    "グラムール美容専門学校",
    "大阪中央理容美容専門学校",
    "大阪美容専門学校",
    "尼崎理容美容専門学校",
    "アルファジャパン美容専門学校",
    "神戸ベルェベル美容専門学校",
    "神戸理容美容専門学校",
    "姫路理容美容専門学校",
    "BEAUTY ARTS KOBE 日本高等美容専門学校",
    "彩ビューティカレッジ",
    "奈良理容美容専門学校",
    "ル・クレエ橿原美容専門学校",
    "IBW美容専門学校",
    "和歌山高等美容専門学校",
    "鳥取県理容美容専門学校",
    "島根県立東部高等技術校（美容科）",
    "浜田ビューティーカレッジ",
    "松江理容美容専門大学校",
    "岡山県理容美容専門学校",
    "専門学校 岡山ビューティモード",
    "専門学校 倉敷ビューティーカレッジ",
    "専門学校 マインドビューティーカレッジ",
    "広島県東部美容専門学校",
    "広島県理容美容専門学校",
    "広島ビューティ＆ブライダル専門学校",
    "広島美容専門学校",
    "下関理容美容専門学校",
    "東亜大学 芸術学部（トータルビューティ学科）",
    "山口県理容美容専門学校",
    "YICビューティモード専門学校",
    "専修学校 徳島県美容学校",
    "専門学校 徳島穴吹カレッジ",
    "徳島県立中央テクノスクール",
    "専修学校 香川県美容学校",
    "専門学校 穴吹ビューティカレッジ 高松",
    "一般社団法人 宇和島美容学校",
    "愛媛県美容専門学校",
    "河原ビューティモード専門学校",
    "東予理容美容専門学校",
    "高知理容美容専門学校",
    "龍馬デザイン・ビューティ専門学校",
    "飯塚理容美容専門学校",
    "大村美容ファッション専門学校",
    "九州CTB理容美容専門学校",
    "福岡南美容専門学校",
    "福岡芸術高等学校",
    "福岡ビューティーアート専門学校",
    "福岡理容美容専門学校",
    "福岡美容専門学校 北九州校",
    "福岡ベルエポック美容専門学校",
    "福岡美容専門学校 福岡校",
    "麻生美容専門学校",
    "ハリウッドワールド美容専門学校",
    "アイビービューティカレッジ",
    "エッジ国際美容専門学校",
    "佐世保美容専門学校",
    "長崎県美容専門学校",
    "九州美容専門学校",
    "熊本高等理容学校",
    "熊本ベルェベル美容専門学校",
    "専修学校 モア・ヘアメイクカレッジ",
    "八代実業専門学校（美容師養成科）",
    "明日香美容文化専門大学校",
    "アンビシャス国際美容学校",
    "明星国際ビューティカレッジ",
    "宮崎サザンビューティ美容専門学校",
    "宮崎美容専門学校",
    "赤塚学園美容・デザイン専門学校",
    "鹿児島県美容専門学校",
    "鹿児島県理容美容専門学校",
    "鹿児島レディスカレッジ",
    "沖縄ビューティー＆ブライダル専門学校",
    "専修学校 ビューティーモードカレッジ",
    "大育理容美容専門学校",
    "琉美インターナショナルビューティーカレッジ",
];

const DefaultInput: React.FC<DefaultInputProps> = ({ value, setValue }) => {

  const [ stationSwitch, setStationSwitch ] = useState(false);

  const options = schoolOptions;

  return (
    <>
    <div className={Styles.box}>
      <input placeholder='〇〇美容学校' value={value} onChange={(e) => setValue(e.target.value)} onFocus={() => setStationSwitch(true)} id='school' maxLength={26} />
      {stationSwitch ?
        <div onClick={() => setStationSwitch(false)}>
          {options.filter(deta => deta.includes(value)).map((deta, i) =>
            <p key={i} onClick={() => setValue(deta)}>{deta}</p>)}
        </div>
      : <></> }
    </div>
    </>
  );
}

export default DefaultInput;




